import Component from '../core/Component';

export default class FiedlContent extends Component {

    constructor($element) {
        super($element);
        this.$close = this.$element.find('.field-content__close');
        this.$prev = this.$element.find('.field-content__arrow--prev');
        this.$next = this.$element.find('.field-content__arrow--next');
    }

    prepare() {

        this.$close.on('click', event => {
            event.preventDefault();
            $('.field').removeClass('is-active');
            this.$element.removeClass('is-active').slideUp(250, () => {
                $('.tabs-content.is-active').trigger('setWrapHeight');
            });
        });

        this.$prev.on('click', event => {
            if (this.$element.prev().prev().prev().length > 0) {
                this.$element.prev().prev().prev().trigger('click');
            } else {
                $('.field').eq($('.field').length-1).trigger('click');
            }
        });

        this.$next.on('click', event => {
            if (this.$element.next().length > 0) {
                this.$element.next().trigger('click');
            } else {
                $('.field:first-child').trigger('click');
            }
        });
    }
}


// WEBPACK FOOTER //
// ./components/FieldContent.js